import { render } from "./EmpleadoIdentificacionTipoForm.vue?vue&type=template&id=01eba23f&scoped=true"
import script from "./EmpleadoIdentificacionTipoForm.vue?vue&type=script&lang=js"
export * from "./EmpleadoIdentificacionTipoForm.vue?vue&type=script&lang=js"

import "./EmpleadoIdentificacionTipoForm.vue?vue&type=style&index=0&id=01eba23f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01eba23f"]])

export default __exports__